// Helper function to log Firestore operations
export const logFirestoreOperation = (operation, path, data) => {
  console.log(`Firebase ${operation} operation:`, {
    path,
    data: data ? JSON.stringify(data) : "No data",
  });
};
